/* eslint-disable indent */
import { COLORS, newLayout } from '../../../theme';

export const popperStyles = {
  // days view
  '& *': {
    '&::-webkit-scrollbar': { display: 'none' },
  },

  '& .MuiPaper-root': {
    borderRadius: newLayout.borderRadius.primary,
    border: `1px solid ${COLORS.black10}`,
    boxShadow: '0 30px 40px rgba(0, 0, 0, 0.15)',
  },

  '& .MuiPickersCalendarHeader-labelContainer': {
    color: COLORS.black60,
    fontSize: 18,
  },

  '& .MuiPickersArrowSwitcher-button.Mui-disabled': {
    path: {
      fill: COLORS.black50,
    },
  },

  '& .MuiDayPicker-weekDayLabel': {
    color: COLORS.black30,
    fontSize: newLayout.fontSize.body2,
    fontWeight: 500,
  },

  '& .MuiPickersDay-root': {
    fontSize: newLayout.fontSize.body1,
    border: '1px solid transparent',
    borderRadius: newLayout.borderRadius.secondary,

    '&.Mui-disabled': {
      color: COLORS.black50,
    },

    '&:hover': {
      color: COLORS.kinetikBlack,
      backgroundColor: COLORS.black10,
      borderColor: 'transparent',
    },
  },

  '&& .MuiPickersDay-today': {
    color: COLORS.kinetikBlue,
    backgroundColor: COLORS.blueLight,
    borderColor: COLORS.kinetikBlue,
  },

  '&& .MuiPickersDay-today.Mui-focusVisible': {
    color: COLORS.kinetikBlue,
    backgroundColor: COLORS.blueLight,
  },

  '& .MuiPickersDay-root.Mui-selected, & .MuiPickersDay-root.Mui-selected:focus':
    {
      color: COLORS.white,
      background: COLORS.kinetikBlue,
      fontWeight: 400,
    },

  '&& .MuiPickersDay-dayOutsideMonth': {
    color: COLORS.black40,
  },

  '& .MuiDateRangePickerDay-rangeIntervalDayHighlight': {
    background: COLORS.kinetikBlue,

    '.MuiPickersDay-root': {
      color: COLORS.white,
    },
  },

  // years view

  '.PrivatePickersYear-yearButton': {
    fontSize: newLayout.fontSize.body1,
    border: '1px solid transparent',
    borderRadius: newLayout.borderRadius.secondary,

    '&.Mui-disabled': {
      color: COLORS.black50,
    },

    '&.Mui-selected': {
      background: COLORS.kinetikBlue,
    },
  },
};
